import { messages as validationMessages } from '@/translation/i18n'
import { localize, setLocale } from '@vee-validate/i18n'
import pl from '@vee-validate/i18n/dist/locale/pl.json'
import { email, max, required } from '@vee-validate/rules'
import { configure, defineRule } from 'vee-validate'

configure({
  generateMessage: localize('pl', {
    messages: {
      ...pl.messages,
      ...validationMessages.pl.validation
    }
  })
})

setLocale('pl')

const regExp = {
  name: /^[A-ZĄĆĘŚŁŃÓŻŹ\s-–'’]*$/i,
  regularField: /^[A-ZĄĆĘŚŁŃÓŻŹ0-9\s!@#$%^&*+_:;?"~/,[\]()–'.-]*$/i,
  phone: /^\+?[0-9]{9,21}$/
}

defineRule('required', required)

defineRule('email', email)

defineRule('email_without_polish', (value) =>
  /^(([^!#$%^&*~`/?'|{}+=<>()[\]\\.,;:\s@"ĄĆĘŚŁŃÓŻŹąćęśłńóżź]+(\.[^<>()[\]\\.,;:\s@"ĄĆĘŚŁŃÓŻŹąćęśłńóżź]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    value
  )
)

defineRule('name', (value) => value.match(regExp.name))

defineRule('max', max)

defineRule('regularField', (value) => {
  if (!value) return true
  const trimmed = value.trim()
  return trimmed?.match(regExp.regularField)
})

defineRule('phoneNumber', (value) => {
  if (!value) return false
  const withoutSpaces = value.replace(/\s/g, '')
  return withoutSpaces?.match(regExp.phone)
})
